module.exports = __webpack_public_path__ + "media/images/card_visa-e4f95386bcfc117456783d80faffd8e0.jpg";